import { AxiosResponse } from 'axios';
import http from '../common/http';
import { SectorPayload } from '../components/AdminDashboard/Pages/SectorsManagement/Interfaces/SectorPayload';

export interface SectorSearchResponse {
  id: string;
  activityName: string;
}

class SectorsService {
  create(payload: SectorPayload): Promise<AxiosResponse> {
    return http.post(`/sectors`, payload);
  }

  update(payload: SectorPayload, id: string): Promise<AxiosResponse> {
    return http.patch(`/sectors/${id}`, payload);
  }

  delete(id: string): Promise<AxiosResponse> {
    return http.delete(`/sectors/${id}`);
  }

  getById(id: string): Promise<AxiosResponse> {
    return http.get(`/sectors/${id}`);
  }

  search(keyword: string): Promise<AxiosResponse<SectorSearchResponse[]>> {
    return http.get(`/sectors/search?activityName=${keyword}`);
  }
}

export default new SectorsService();
